import React, { useMemo } from 'react';
import Business from '@material-ui/icons/Business';
import { SingleDepartment } from 'utils/api/models/departments/singleDepartment';
import { BodyS } from 'components/Typography/Typography';
import SummaryRow from 'components/SummaryRow/SummaryRow';
import Badge from 'components/Badge/Badge';
import { translate } from 'components/Translation';
import { SingleCorpAccount } from 'utils/api/models/accounts/singleCorpAccount';
import styles from 'assets/jss/material-dashboard-pro-react/views/users/addUserDialogStyle';
import { makeStyles } from '@material-ui/core';
import { ExpirationDateSummaryRow } from 'views/Users/common/AddUserDialog/subcomponents/SummaryTab';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IDepartmentsSummaryProps {
	departments: SingleDepartment[];
	accounts: SingleCorpAccount[];
	expirationDate: moment.Moment | null;
	unlimitedExpirationDate: boolean;
}

const DepartmentsSummary = ({
	departments,
	accounts,
	expirationDate,
	unlimitedExpirationDate,
}: IDepartmentsSummaryProps) => {
	const classes = useStyles();

	const groupedDepartments = useMemo(() => {
		return accounts
			.map((account) => {
				const filteredDepartments = departments.filter(
					(department) => String(department.accountId) === account.accountId
				);
				return {
					...account,
					departments: filteredDepartments,
				};
			})
			.filter((account) => account.departments.length > 0);
	}, [accounts, departments]);

	return (
		<div>
			{groupedDepartments.map((account, index) => (
				<div key={account.accountId}>
					<BodyS>{`${translate('permission')} ${index + 1}`}</BodyS>
					<ExpirationDateSummaryRow
						expirationDate={expirationDate}
						unlimitedExpirationDate={unlimitedExpirationDate}
					/>
					<SummaryRow
						label={translate('organization.name')}
						value={account.accountName}
						className={classes.smallMargin}
						withBorder={false}
						icon={<Business />}
					/>
					<SummaryRow
						label={translate('departments')}
						className={classes.mediumMargin}
						value={
							<div className={classes.badges}>
								{account.departments.map((department) => (
									<Badge
										hexColor={department.uiColor}
										key={department.deptId}
										filled
										className={classes.departmentBadge}
									>
										{department.name}
									</Badge>
								))}
							</div>
						}
					/>
				</div>
			))}
		</div>
	);
};

export default DepartmentsSummary;
